import Vue from 'vue'
import App from './App.vue'
import router from './router'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

import Nav from './components/Nav.vue'
import Footer from './components/Footer.vue'
Vue.component('Nav', Nav)
Vue.component('Footer', Footer)


Vue.directive('animate', {
  inserted(el, binding) {
  
    const defaultOpts = {
      type: 'fadeUp',   
      duration: 800,
      delay: 0,
      easing: 'easeOutQuart'
    }
    const opts = { ...defaultOpts, ...binding.value }


    if (opts.type === 'fadeUp') {
      el.style.transform = 'translateY(60px)'
    } else if (opts.type === 'scale') {
      el.style.transform = 'scale(0.9)'
    } else if (opts.type === 'fadeLeft') {
      el.style.transform = 'translateX(-60px)'
    } else if (opts.type === 'fadeRight') {
      el.style.transform = 'translateX(60px)'
    }
    el.style.opacity = 0
    el.style.transition = `all ${opts.duration}ms ${opts.easing} ${opts.delay}ms`


    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            el.style.transform = 'translate(0) scale(1)'
            el.style.opacity = 1
          }, 50)
          observer.unobserve(el) 
        }
      },
      { threshold: 0.1 } 
    )
    observer.observe(el)
  }
})

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')